import * as React from 'react'
// import { motion, useMotionValue, useAnimation } from 'framer-motion'
import { Text } from '../text'
import { interpolate, EasingType } from '../../anim/interpolate'

type MotionValueProps = any & {
	fromValue: number,
	toValue: number,
	duration?: number
	easing?: string | EasingType
	formatter?: (value: number) => string
}

const MotionValue: React.FC<MotionValueProps> = (props: MotionValueProps): React.ReactElement => {
	const {
		fromValue,
		toValue,
		duration,
		delay,
		easing,
		timing,
		formatter,
		...rest
	} = props

	// const x = useMotionValue(fromValue)
	// const controls = useAnimation()

	const [value, setValue] = React.useState(0)
	const [lastValue, setLastValue] = React.useState(0)
	const [displayValue, setDisplayValue] = React.useState('--')

	const updateDisplayValue = (value: number) => {
		let result = `${Math.round(value)}`
		if (formatter) {
			result = formatter(value)
		}
		setDisplayValue(result)
	}

	const update = (toValue: number) => {
		if (easing !== 'none') {
			interpolate(lastValue, toValue, { duration, delay, easing, timing }, (value: number) => {
				updateDisplayValue(value)
			})
		} else {
			updateDisplayValue(toValue)
		}
		setLastValue(toValue)
	}

	React.useEffect(() => {
		setLastValue(fromValue)
		setValue(toValue)
	}, [fromValue, toValue])

	React.useEffect(() => {
		update(value)
	}, [value])

	return (
		<Text {...rest}>{displayValue}</Text>
	)
}

MotionValue.defaultProps = {
	fromValue: 0,
	duration: 1,
	easing: 'linear'
}

export default MotionValue
